import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-tin-mask-renderer",
  imports: [MatIconModule, CommonModule],
  templateUrl: "./tin-mask-renderer.component.html",
  styleUrl: "./tin-mask-renderer.component.css",
})
export class TinMaskRendererComponent implements ICellRendererAngularComp {
  showTin = false;
  tinValue = "";

  agInit(params: ICellRendererParams): void {
    this.tinValue = params.value ?? "";
  }

  refresh(params: ICellRendererParams): boolean {
    this.tinValue = params.value ?? "";
    return true;
  }

  getMaskedTin(): string {
    if (!this.tinValue || this.tinValue.length <= 4) return this.tinValue;
    return "*".repeat(this.tinValue.length - 4) + this.tinValue.slice(-4);
  }

  toggleShowTin(event: MouseEvent): void {
    event.stopPropagation();
    this.showTin = !this.showTin;
  }
}
